<div class="ws-flex-container-vertical ws-flex-auto">
    <div class="entity-header">
        @if (originalSite) {
            <ol class="breadcrumb float-start">
                <li class="breadcrumb-item">
                    <a class="pointer" (click)="navigateToCompany()">{{ originalSite.company.companyName }}</a>
                </li>
                <li class="breadcrumb-item">
                    <a class="pointer" (click)="navigateToOriginalSite()">{{ originalSite.name }}</a>
                </li>
            </ol>
        }
        <div class="clearfix"></div>
    </div>
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title">Site Map</h4>
        </div>
    </div>
    <div class="ws-flex-container-horizontal ws-stretch ws-overflow-auto">
        @if (propertyTypes.length && siteClasses.length && originalSite) {
            <div class="site-map-filters">
                <div class="ws-flex-container-vertical ws-flex-auto">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" (change)="limitToParentCompany($event)"> Limit
                            to {{ originalSite.company.companyName }}
                        </label>
                    </div>
                </div>
                <div class="ws-flex-container-vertical ws-flex-auto">
                    <label class="ws-flex-none">Property types:</label>
                    <select multiple
                            class="filter-select prop-type-multi"
                            (change)="propertyTypesSelected($event.target)">
                        @for (type of propertyTypes; track type) {
                            <option [value]="type.propertyTypeID"
                                    [selected]="filters.propertyTypeIds.includes(type.propertyTypeID)">
                                {{ type.propTypeName }}
                            </option>
                        }
                    </select>
                </div>
                <div class="ws-flex-container-vertical ws-flex-auto">
                    <label class="ws-flex-none">Site classes:</label>
                    <select multiple
                            class="filter-select site-class-multi"
                            (change)="siteClassesSelected($event.target)">
                        @for (siteClass of siteClasses; track siteClass) {
                            <option [value]="siteClass.siteClassPrimaryID"
                                    [selected]="filters.siteClassPrimaryIds.includes(siteClass.siteClassPrimaryID)">
                                {{ siteClass.siteClassPrimaryDesc }}
                            </option>
                        }
                    </select>
                </div>
                <div class="number-filters">
                    <div class="ws-flex-container-horizontal ws-flex-auto">
                        <label class="ws-flex-none">Min SqFt:</label>
                        <input type="number" class="form-control" [(ngModel)]="filters.minSqFt">
                    </div>
                    <div class="ws-flex-container-horizontal ws-flex-auto">
                        <label class="ws-flex-none">Max SqFt:</label>
                        <input type="number" class="form-control" [(ngModel)]="filters.maxSqFt">
                    </div>
                    <div class="ws-flex-container-horizontal ws-flex-auto">
                        <label class="ws-flex-none">Min Units:</label>
                        <input type="number" class="form-control" [(ngModel)]="filters.minUnits">
                    </div>
                    <div class="ws-flex-container-horizontal ws-flex-auto">
                        <label class="ws-flex-none">Max Units:</label>
                        <input type="number" class="form-control" [(ngModel)]="filters.maxUnits">
                    </div>
                </div>
                <div class="ws-flex-container-vertical ws-flex-auto">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" [(ngModel)]="filters.onlyUnderAppeal"> Under appeal
                        </label>
                    </div>
                </div>
                <div class="ws-flex-container-vertical ws-flex-auto" style="margin-top: 30px;">
                    <button type="button" class="ace-btn btn-primary" (click)="getNewSites$.next()">Apply</button>
                </div>
            </div>
        }
        <div style="width: 100%; height: 100%;">
            @if (originalSite) {
                <google-map
                    #map
                    [center]="originalCenter"
                    [zoom]="startingZoom"
                    height="100%"
                    width="100%"
                    [options]="mapOptions"
                    (idle)="mapIdle()"
                    (boundsChanged)="boundsChanged()"
                    (zoomChanged)="zoomChanged()">
                    @if (isOriginalSiteIncluded) {
                        <map-marker
                            #origSiteMarkerElem="mapMarker"
                            [position]="originalCenter"
                            [options]="markerOptions"
                            (mapMouseover)="debouncedGetSiteInfo(originalSite.siteID, origSiteMarkerElem)"
                            (mapMouseout)="mouseOutOfPin(originalSite.siteID)">
                            <map-info-window [options]="infoWindowOptions">
                                <site-map-info-window [siteMarkerInfoArr]="siteMarkerInfoArr"
                                                      (mouseenter)="mouseEnterWindow()"
                                                      (mouseleave)="mouseleaveWindow()">
                                </site-map-info-window>
                            </map-info-window>
                        </map-marker>
                    }
                    <map-marker-clusterer [renderer]="clusterRenderer">
                        @for (site of sitesToDisplay; track site) {
                            <map-marker
                                #siteMarkerElem="mapMarker"
                                [position]="site.center"
                                [options]="site.markerOptions"
                                (mapMouseover)="debouncedGetSiteInfo(site.siteId, siteMarkerElem, site.stackId)"
                                (mapMouseout)="mouseOutOfPin(site.siteId)">
                            </map-marker>
                        }
                        <map-info-window [options]="infoWindowOptions">
                            <site-map-info-window [siteMarkerInfoArr]="siteMarkerInfoArr"
                                                  (mouseenter)="mouseEnterWindow()"
                                                  (mouseleave)="mouseleaveWindow()">
                            </site-map-info-window>
                        </map-info-window>
                    </map-marker-clusterer>
                </google-map>
            }
        </div>
    </div>
</div>
